<template>
    <v-chip x-small color="error">Zablokowany</v-chip>
</template>

<script>
export default {
  name: "ChipBlocked",
}
</script>